var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newsDetail", "data-role": "page" } },
    [
      !_vm.closeOffline && _vm.isOffline
        ? _c("div", { staticClass: "v3offline" }, [
            _c("i", { staticClass: "icon-exclamation-mark-circle" }),
            _vm._v(" "),
            _c("p", [_vm._v("未連接至網路")]),
            _vm._v(" "),
            _c("div", { on: { click: _vm.closeOfflineHandle } }, [
              _c("i", { staticClass: "icon-close" })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "newsDetail-content",
          attrs: { id: "v3newsDetail", "data-position": "fixed" }
        },
        [
          _c("div", { staticClass: "detailWrap" }, [
            _c("div", { staticClass: "detail-h" }, [
              _c("span", { staticClass: "cgy-tag" }, [
                _vm._v(_vm._s(_vm.News.type_name))
              ]),
              _vm._v(" "),
              _c("h3", { class: { LargSize: _vm.fz_larg } }, [
                _vm._v(_vm._s(_vm.News.title))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "article_date",
                  class: { LargSize: _vm.fz_larg }
                },
                [_vm._v(_vm._s(_vm.News.news_date))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-c" }, [
              _vm.News.title_img !== ""
                ? _c("img", {
                    staticClass: "mainImg",
                    attrs: { src: _vm.News.title_img }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.News.title_img == ""
                ? _c("div", {
                    staticClass: "mainImg",
                    style: { height: "250px" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "txtContent", class: { LargSize: _vm.fz_larg } },
                _vm._l(_vm.News.content, function(html, index) {
                  return _c("div", { key: index }, [
                    html !== "AD"
                      ? _c("p", { domProps: { innerHTML: _vm._s(html) } })
                      : _vm._e(),
                    _vm._v(" "),
                    html === "AD"
                      ? _c(
                          "div",
                          [
                            [
                              _c("script2", {
                                attrs: {
                                  type: "text/javascript",
                                  async: "true",
                                  src:
                                    "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
                                }
                              }),
                              _vm._v(" "),
                              _c("ins", {
                                staticClass: "adsbygoogle",
                                style: "display:block; text-align:center;",
                                attrs: {
                                  "data-ad-layout": "in-article",
                                  "data-ad-format": "fluid",
                                  "data-ad-client": "ca-pub-9449560331897859",
                                  "data-ad-slot": "9862565468",
                                  "data-full-width-responsive": "yes"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "script2",
                                { attrs: { type: "text/javascript" } },
                                [
                                  _vm._v(
                                    " (adsbygoogle = window.adsbygoogle || []).push({}); "
                                  )
                                ]
                              )
                            ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                })
              )
            ]),
            _vm._v(" "),
            _vm.MoreNewsRule.length != 0
              ? _c("div", { staticClass: "detail-ref" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.MoreNewsRule, function(rule, rule_ind) {
                      return _c(
                        "li",
                        { key: rule_ind },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "legalRuleDetail",
                                  params: { id: rule.rule_id }
                                }
                              }
                            },
                            [_vm._v(_vm._s(rule.rule_name))]
                          )
                        ],
                        1
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "detail-source" }, [
              _c("h4", [_vm._v("文章來源")]),
              _vm._v(" "),
              _c("div", { staticClass: "logowrap" }, [
                _c("p", { staticClass: "s-name" }, [
                  _vm._v(_vm._s(_vm.News.legal_name))
                ]),
                _vm._v(" "),
                _vm.News.legal_logo != null
                  ? _c("div", { staticClass: "logoImg" }, [
                      _c("img", {
                        attrs: { src: _vm.News.legal_logo, alt: "" }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "descwrap" }, [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.News.about) +
                    "\n                        "
                ),
                _vm.News.multiLink && _vm.News.multiLink !== "[]"
                  ? _c(
                      "span",
                      {
                        staticClass: "more",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.windowsOpen(_vm.News.multiLink)
                          }
                        }
                      },
                      [_vm._v(" <<查看更多")]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm.MoreNews.length > 0
            ? _c("div", { staticClass: "detailWrap articleWrap" }, [
                _c("div", { staticClass: "detail-c" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.CleanGotoNewsPage(_vm.News.news_type)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "moreBtn-rt" }, [
                        _vm._v("查看更多 >")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "articleList" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.MoreNews, function(news, MoreNews_ind) {
                        return _c("li", { key: MoreNews_ind }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  _vm.nextPage(news.news_id)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "articleTag" }, [
                                _vm._v(_vm._s(news.news_type))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "articleContent" }, [
                                news.title_img !== ""
                                  ? _c("div", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy:background-image",
                                          value: news.title_img,
                                          expression: "news.title_img",
                                          arg: "background-image"
                                        }
                                      ],
                                      staticClass: "articleContentImg"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                news.title_img == ""
                                  ? _c("div", {
                                      staticClass: "articleContentImg"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "articleContentNote" },
                                  [_vm._v(_vm._s(news.title))]
                                ),
                                _vm._v(" "),
                                _vm._m(3, true)
                              ])
                            ]
                          )
                        ])
                      })
                    ),
                    _vm._v(" "),
                    _vm.MoreNews_row <= this.MoreNews.length &&
                    this.MoreNews.length >= 10
                      ? _c("div", { staticClass: "moreBtn" }, [
                          _c("p", { staticClass: "loading-rotate" }),
                          _vm._v(" "),
                          _c("p", { staticClass: "loading-tip" }, [
                            _vm._v("載入更多")
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.hasToken
        ? _c(
            "div",
            {
              staticClass: "qk-functionBar active",
              attrs: { id: "v3functionBar" }
            },
            [
              _c("div", { class: ["qk-functionBar-wrap-col4"] }, [
                _c(
                  "div",
                  {
                    class: { active: _vm.News.is_push },
                    on: {
                      click: function($event) {
                        _vm.SetRecommend(_vm.News.news_id, _vm.News.is_push)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _c("i", {
                        class: [
                          _vm.News.is_push ? "icon-like-full" : "icon-like-line"
                        ]
                      }),
                      _vm._v("推")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: { active: _vm.News.is_keep },
                    on: {
                      click: function($event) {
                        _vm.SetFavorites(_vm.News.news_id, _vm.News.is_keep)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _c("i", {
                        class: [
                          _vm.News.is_keep
                            ? "icon-saved-full"
                            : "icon-saved-line"
                        ]
                      }),
                      _vm._v("收藏")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: { active: _vm.fz_larg },
                    on: { click: _vm.ChanegSize }
                  },
                  [_vm._m(4)]
                ),
                _vm._v(" "),
                _c("div", { on: { click: _vm.Share } }, [_vm._m(5)])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.appAlertDisplay
        ? _c("div", {
            staticClass: "appAlertMask",
            on: {
              touchmove: function($event) {
                $event.preventDefault()
              },
              click: function() {
                return (this$1.appAlertDisplay = !this$1.appAlertDisplay)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.appAlertDisplay
        ? _c("div", { staticClass: "appAlert" }, [
            _c("div", { staticClass: "appAlertTitle" }, [_vm._v("系統提示")]),
            _vm._v(" "),
            _c("div", { staticClass: "appAlertNote" }, [
              _vm._v("此功能限定會員使用，現在就加入會員吧！")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "appAlertButton" }, [
              _c("span", { on: { click: _vm.backToApp } }, [
                _vm._v("加入會員")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function() {
                      return (this$1.appAlertDisplay = !this$1.appAlertDisplay)
                    }
                  }
                },
                [_vm._v("暫時不用")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.v3Toast.show,
              expression: "v3Toast.show"
            }
          ],
          staticClass: "v3Toast"
        },
        [_vm._v(_vm._s(_vm.v3Toast.text))]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c("i", { staticClass: "icon-article-pen" }),
      _vm._v("公寓大廈管理條例相關法條")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detailWrap articleWrap questionnaire" }, [
      _c("div", { staticClass: "detail-c" }, [
        _c("div", { staticClass: "questionnaire" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform"
              }
            },
            [
              _c("div", { staticClass: "img" }),
              _vm._v(" "),
              _c("div", { staticClass: "txt" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v("想看什麼快來許願吧！")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "content" }, [
                  _vm._v("不管你想看甚麼,我們都幫你準備。")
                ])
              ])
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "cgyTitle" }, [
      _c("i", { staticClass: "titleIcon icon-article-pen" }),
      _vm._v("相關文章")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "articleContentIcon" }, [
      _c("i", { staticClass: "icon-right-roundedline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon-font-size" }),
      _vm._v("大小")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-export" }), _vm._v("分享")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7471aefa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7471aefa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/newsDetail.vue
// module id = null
// module chunks = 